import { UntypedFormControl } from '@angular/forms';

export const groupRadioButtonValidator = (ctrl: UntypedFormControl): { unchecked: boolean } | null =>
{
    ctrl.markAsTouched();

    if (ctrl.value)
    {
        return null;
    }

    return {
        unchecked: true
    };
};
